const data = {
  id: 1,
  title: 'Listen, choose the correct pronunciation for ‘ed’.',
  subTitle: 'Nghe, chọn cách phát âm đúng của ‘ed’.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/817bcaef-35f3-43f6-9213-6eec28023703.mp3',
  answers: [
    { id: 1, answer: '/id/ ', isCorrect: false },
    { id: 2, answer: '/d/ ', isCorrect: true },
    { id: 3, answer: '/t/', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
